export interface SelectOption<V = string, L = string> {
  label: L;
  value: V;
}

/** Legal form */
export type LegalForm =
  | 'None'
  | 'Private'
  | 'Business'
  | 'Association'
  | 'Authority';

export const LEGAL_FORM_VALUES: Record<number, LegalForm> = {
  0: 'None',
  1: 'Private',
  2: 'Business',
  3: 'Association',
  4: 'Authority',
};

export const OPTIONS_LEGAL_FORM: SelectOption<LegalForm, LegalForm>[] = [
  { label: 'None', value: 'None' },
  { label: 'Private', value: 'Private' },
  { label: 'Business', value: 'Business' },
  { label: 'Association', value: 'Association' },
  { label: 'Authority', value: 'Authority' },
];

/** Salutation */

export type SalutationType = 'None' | 'Female' | 'Male' | 'Family' | 'Divers';

export const SALUTATION_VALUES: Record<number, SalutationType> = {
  0: 'None',
  1: 'Female',
  2: 'Male',
  3: 'Family',
};

export const OPTIONS_SALUTATION: SelectOption<SalutationType>[] = [
  { label: 'Keine', value: 'None' },
  { label: 'Frau', value: 'Female' },
  { label: 'Herr', value: 'Male' },
  { label: 'Familie', value: 'Family' },
];

/** Title */

export type Title = 'None' | 'Doctor' | 'Professor';

export const TITLE_VALUES: Record<number, Title> = {
  0: 'None',
  1: 'Doctor',
  2: 'Professor',
};

export const OPTIONS_TITLE: SelectOption<Title>[] = [
  { label: 'Keiner', value: 'None' },
  { label: 'Dr.', value: 'Doctor' },
  { label: 'Prof.', value: 'Professor' },
];

/** Extended business partner info */

export interface IAdvertisementConsentList {
  agreement: boolean;
  businessPartnerNumber: string;
  comChannelType: string;
  consentDate: string;
  id: number;
  lastAdvertisingUsage: string;
  optInOriginalWording: string;
  value: string;
}

export interface IPhoneNumber {
  advertisementConsentROList: IAdvertisementConsentRolist[];
  businessPartner: number;
  creationDate: string;
  fax: string;
  id: number;
  number: string;
  reachability: string;
  type: string;
}

export interface IAdvertisementConsentRolist {
  agreement: boolean;
  businessPartnerNumber: string;
  comChannelType: string;
  consentDate: string;
  id: number;
  lastAdvertisingUsage: string;
  optInOriginalWording: string;
  value: string;
}

// Extended 'ISearchBusinessPartner' interface
export interface ILoadBusinessPartner {
  firstName: string;
  name: string;
  email: string;
  title: number | null;
  salutation: number;
  legalForm: number;
  id: number;
  businessPartnerNumber: string;
  dateOfBirth: number;
  taxNumberIdent: string;
  ilnCode: string;
  foundationYear: string;
  districtCourt: string;
  registerNr: string;
  businessPartnerPassword: string;
  changeDate: string;
  changeDuration: string;
  note: string;
  creditRatingDate: string;
  creditRatingResult: string;
  creditRatingOk: string;
  migBusinessPartnerKey: string;
  creditorIdentification: string;
  portalActivationDate: string;
  phoneNumbers: IPhoneNumber[];
  bankAccounts: IBankAccount[] | null;
  address: IAddress | null;
  marketResearchAgreed: boolean;
  telephoneAdvertisingAgreed: boolean;
  advertisementConsentList: IAdvertisementConsentList[];
}

export interface IPointOfDelivery {
  pointOfDelivery: number;
}

export interface IBankAccount {
  periodStart: string;
  periodEnd: string;
  id: number;
  paymentType: string;
  accountNo: string;
  bankCode: string;
  bankName: string;
  iban: string;
  bic: string;
  changeDate: string;
  changeDuration: string;
  debitAllowed: boolean | null;
  creditAllowed: boolean | null;
  debitor: IPointOfDelivery[];
  credit: IPointOfDelivery[];
  owner: number;
  ownerName: string;
}

export interface IAddress {
  periodStart: number;
  periodEnd: string;
  id: number;
  street: string;
  housenumber: string;
  housenumberAddition: string;
  postalCode: string;
  city: string;
  cityAddition: string;
  federalState: string;
  adressAddition: string;
  changedCreateE03: boolean;
  country: string;
  adressAddition1: string;
  adressAddition2: string;
  adressAddition3: string;
  adressAddition4: string;
}
